import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteLoaderData } from 'react-router';
import { dsClass } from '../../../../../common/constants/dsClasses.js';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { ModelType } from '../../../../../common/enums.js';
import {
  newSubscriptionMsg,
  omaElisaForCompaniesMsg,
  t,
  voiceSubscriptionsMsg,
} from '../../../../../common/i18n/index.js';
import { AnalyticsEventOrigins } from '../../../../../common/utils/analyticsUtils';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { CardSelectionHeader } from '../../../../../components/OrderSubscriptionSelection/CardSelectionHeader.js';
import { Disclaimer } from '../../../../../components/OrderSubscriptionSelection/Disclaimer.js';
import { OrderSubscriptionSelection } from '../../../../../components/OrderSubscriptionSelection/OrderSubscriptionSelection.js';
import { SubscriptionCardsByModelTypeWrapper } from '../../../../../components/OrderSubscriptionSelection/SubscriptionCardsByModelTypeWrapper.js';
import { applyWizardEvent } from '../../../../../selfservice/actions/index.js';
import { OrderSubscriptionSelectionHeader } from './OrderSubscription/OrderSubscriptionSelectionHeader.js';
import type { OrderSubscriptionCommonLoaderData } from '../../../../../common/loaders.js';
import type { OnlineModel } from '../../../../../generated/api/models.js';

export const MobileSubNewPath = () => {
  const dispatch = useDispatch();

  const loaderData = useRouteLoaderData('newVoiceSubCommon') as OrderSubscriptionCommonLoaderData | undefined;
  const loaderModels = loaderData?.onlineModels ?? [];
  const hideYrityspuheUUSI = loaderData?.companyInfo?.hideYrityspuheUUSI;
  const visibleOffers = loaderData?.companyInfo?.uiOptions?.visibleOffers;

  const minuteModels = loaderModels.filter(
    (model: OnlineModel) =>
      model.onlineModelCode === ModelType.VoiceYrityspuhe || model.onlineModelCode === ModelType.VoicePerusliittyma4g
  );

  useEffect(() => {
    dispatch(applyWizardEvent(1, 'NEW_VOICE_SUBSCRIPTION'));
  }, [dispatch]);

  return (
    <>
      <OrderSubscriptionSelectionHeader
        breadCrumbs={
          <BreadCrumbsWithTitle
            breadCrumbPaths={[
              { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
              { name: t.AR0B(voiceSubscriptionsMsg), path: paths.PS_MOBILE_SUBSCRIPTIONS },
              { name: t.OK8J(newSubscriptionMsg) },
            ]}
          />
        }
      />
      <Grid>
        <div className={`${dsClass.MARGIN_TOP_6} ${dsClass.PADDING_BOTTOM_7}`}>
          <CardSelectionHeader onlineModelType={ModelType.YrityspuheUusi} />
          {!hideYrityspuheUUSI && (
            <SubscriptionCardsByModelTypeWrapper
              onlineModelType={ModelType.YrityspuheUusi}
              eventOrigin={AnalyticsEventOrigins.OMAELISA}
              wide
            />
          )}
          <OrderSubscriptionSelection
            onlineModelType={ModelType.YrityspuheUusi}
            onlineModels={loaderModels}
            minuteModels={minuteModels}
            visibleOffers={visibleOffers}
            hideYrityspuheUUSI={hideYrityspuheUUSI}
            showOnlyMinuteAndLegacy
            isChangeOffer={false}
            eventOrigin={AnalyticsEventOrigins.OMAELISA}
          />
          <Disclaimer />
        </div>
      </Grid>
    </>
  );
};
